<app-select-input
    [form]="form"
    id="userId"
    [infiniteScroll]="userScroll()"
    valueKey="id"
    (selectedValueChange)="selectedUser.emit($event)"
    [disabled]="disabled()"
    [label]="label()"
>
    <ng-template #item let-item>
        {{ item | formatPerson }}
    </ng-template>
    <ng-template #selectedItem let-item>
        <app-user-chip
            [user]="item" [renderDetails]="false"
            [renderType]="UserChipRenderTypeEnum.User"
        ></app-user-chip>
    </ng-template>
</app-select-input>
